<template>
  <div
    class="ti-me-login"
    :class="{ 'ti-me-login--vin-hint': vinHint }"
    :style="{
      'background-image': vinHint
        ? `url(${$parseSrc('/assets/confirmation/img_ti_confirmation_blur.jpg')})`
        : '',
    }"
  >
    <!-- TODO: check h4, add translation to phrase -->
    <div class="ti-me-login__heading" v-if="props.vinHint">
      {{ $t('i18n.meSearch.notLoggedIn.headline') }}
    </div>
    <p>{{ $t('i18n.meSearch.notLoggedIn.copy') }}</p>
    <div v-if="props.vinHint" class="ti-me-login__spacer"></div>
    <button
      class="ti-me-login__login-button wb-button"
      :class="
        props.vinHint
          ? 'wb-button--tertiary'
          : 'wb-button--primary wb-button--large'
      "
      @click="login()"
    >
      <wb-icon
        class="wb-button__icon"
        aria-hidden="true"
        flip-rtl
        name="chevron-right"
      ></wb-icon>
      {{ $t('i18n.meSearch.notLoggedIn.button') }}
    </button>
    <button
      v-if="props.vinHint"
      class="ti-me-login__close wb-button wb-button--tertiary"
      @click="emit('close')"
    >
      <wb-icon name="bds/close/24"></wb-icon>
    </button>
  </div>
</template>
<script lang="ts" setup>
import setup from '../../composables/setup';
import {
  AUTHENTICATION_CONNECTION,
  IdentityProvider,
} from '@b2x/authentication-library';

const { store, $parseSrc } = setup();
interface Props {
  vinHint?: boolean;
}

const props = defineProps<Props>();

const emit = defineEmits(['close']);

const login = (): void => {
  store.value
    .getConnectionDispatchers(AUTHENTICATION_CONNECTION)
    .then((dispatchers) => {
      dispatchers.login({
        identityProvider: IdentityProvider.CIAS,
        tenantId: 'oneweb',
      });
    });
};
</script>
<style lang="scss">
.ti-me-login {
  p {
    @include wb-type-copy;
    @include wb-spacing('margin', '18px 0 l 0');
  }

  &__login-button {
    display: block;
    margin: 0 auto;
  }

  &--vin-hint {
    position: relative;
    background-size: cover;
    color: var(--wb-white);
    border: 1px solid var(--wb-grey-20);
    border-radius: 4px;

    .ti-me-login__heading {
      @include wb-type-copy-strong;
      @include wb-spacing('margin', '16px');
      @include wb-spacing('padding-right', '36px');
    }

    p {
      @include wb-type-copy-secondary;
      @include wb-spacing('margin', '16px');
      color: var(--wb-grey-70);
    }

    .ti-me-login__login-button {
      width: 100%;
      margin: 0;
      padding: 16px;
      text-align: left;
    }
  }

  &__close {
    height: 36px;
    width: 36px;
    position: absolute;
    top: 8px;
    right: 8px;
    color: var(--wb-white);
  }

  &__spacer {
    border: 0;
    height: 1px;
    background-color: var(--wb-grey-20);
  }
}
</style>
